<template>
	<div class="modifyPwd">
		<el-dialog :visible.sync="dialogVisible" width="600px" top="26vh" :close-on-click-modal="false" :show-close="false"
			@close="close">
			<div class="title">修改头像</div>
			<span class="iconfont icon-guanbi" @click="dialogVisible = false"></span>
			<div class="avatar-list">
				<div v-for="(item, index) in avatarList" :key="index" class="avatar-item" :class="active==index&&'active'">
					<img :src="item" alt="" @click="active = index">
				</div>
			</div>
			<div class="dialog-footer">
				<el-button type="primary" @click="submitForm" style="background-color: #00E5FF;color: #0C3151;">更 改</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAvatarList,
		setAvatar
	} from '@/api/user'
	export default {
		name: "modifyPwd",
		data() {
			return {
				dialogVisible: false,
				avatarList: [],
				active: 0,
			}
		},
		created: function() {
			this.getAvatarList();
		},
		mounted: function() {},
		methods: {
			show(row) {
				this.dialogVisible = true;
			},
			close() {
				this.dialogVisible = false;
			},
			async submitForm() {
				let res = await setAvatar({
					avatarId: this.active
				});
				if (res.status == 1) {
					this.$store.dispatch('user/getUserInfo');
					this.$message.success(res.message);
					this.close();
				} else {
					this.$message.warning(res.message);
				}
			},
			async getAvatarList() { // 获取头像
				let res = await getAvatarList();
				if (res.status == 1) {
					this.avatarList = res.data;
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.modifyPwd {

		::v-deep .el-dialog {
			background: url(~@/assets/img/pwdBg.png) no-repeat;
			background-size: 100% 100%;
			color: #FFF;
			height: 425px;

			.el-dialog__header {
				display: none;
			}

			.el-dialog__body {
				padding: 83px 25px 30px;
				position: relative;

				.title {
					position: absolute;
					top: 10px;
					left: 50%;
					transform: translate(-50%, 0);
					color: #D4F0FF;
					font-size: 32px;
					font-weight: 400;
				}

				.icon-guanbi {
					position: absolute;
					right: 32px;
					top: 55px;
					color: #98DCFF;
					font-size: 20px;
					cursor: pointer;
				}

				.avatar-list {
					background-color: #16252E;
					border-radius: 20px;
					height: 235px;
					overflow-y: auto;
					overflow-x: hidden;
					display: flex;
					flex-wrap: wrap;
					padding: 25px 15px 0;

					.active img {
						border: 2px solid #01E5FF;
					}

					.avatar-item {
						width: 20%;
						text-align: center;
						padding-bottom: 14px;
						box-sizing: border-box;

						img {
							background-color: #1D526F;
							border-radius: 8px;
							cursor: pointer;
							width: 60px;
							height: 60px;
							box-sizing: border-box;
						}
					}
				}
			}

			.dialog-footer {
				display: flex;
				justify-content: center;
				margin-top: 18px;

				.el-button {
					font-size: 20px;
					padding: 11px 40px;
					border: none;
				}
			}
		}
	}
</style>